/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";

import styles from "./Header.module.scss";
import LogoLarge from "assets/images/logo-large.svg";
import HamburgerMenu from "assets/images/hamburger-menu.svg";
import { uiEvents } from "../../../app-message/events/uiEvents";


export default class Header extends React.Component {
  onDrawerClick = () => {
    uiEvents.onNavigationDrawerMenuClick(true);
  }

  render() {
    return (
      <div className={styles.headerBar}>
        <div className={styles.hamburgerMenu} onClick={this.onDrawerClick}>
          <img alt="logo" src={HamburgerMenu} />
        </div>
        <div className={styles.logo}>
          <img alt="logo" src={LogoLarge} />
        </div>
      </div>
    );
  }
}
